// @flow
import R from "ramda"
import type { Dispatch } from "redux"
import Cookies from "js-cookie"

import { openModal } from "booking/services/modals/actions"
import { RESERVATION_MODALS } from "booking/scenes/Modals/consts/modalsConsts"

const passengerValuesCount = passenger =>
  Object.keys(passenger).filter(
    key => !["bags", "paidHandBags", "nationality", "title"].includes(key) && passenger[key].value,
  ).length

export const PRICE_CHANGE = "priceChange"

// $FlowFixMe: error revealed by updating Flow and Ramda libdef, please fix
export const totalValues = R.compose(
  R.sum,
  R.map(passengerValuesCount),
  state => state?.form?.reservation?.passengers || [],
)

export const triggerPriceChangeModal = (
  props: {
    originalPrice: number,
    resPrice: number,
    passengersCount: number,
  },
  savePriceChange: boolean,
) => (dispatch: Dispatch<any>) => {
  if (savePriceChange) Cookies.set(PRICE_CHANGE, true, { expires: 1 })
  dispatch(openModal(RESERVATION_MODALS.ERROR.PRICE_CHANGE, { ...props }))
}
